import React, { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// Import SVG icons directly
import UserIcon from "../../static/svg/UserIcon";
import Flows from "../../static/images/CrewTiles/Flowtils.svg";
import LogsIcon from "../../static/svg/LogsIcon";
import KnowledgehubIcon from "../../static/svg/KnowledgehubIcon";
import DetailsIcon from "../../static/svg/DetailsIcon";
import KnowledgehubchatgptIcon from "../../static/svg/KnowledgehubchatgptIcon";
import AgentsCrewsIcon from "../../static/svg/AgentsCrewsIcon";
import FlowsCrewIcon from "../../static/svg/FlowsCrewIcon";
import FrequencyCrewIcon from "../../static/svg/FrequencyCrewIcon";
import FineTuneIcon from "../../static/svg/FineTuneIcon";
import FinalOutput from "../../static/svg/FinalOutput";
import ConfigurationsTileIcon from "../../static/svg/ConfigurationsTileIcon";
import BuildCrewTileIcon from "../../static/svg/BuildCrewTileIcon";
import FinetureTile from "../../static/svg/FinetureTile";
import DeployCrewTileIcon from "../../static/svg/DeployCrewTileIcon";
import Agent from "../../static/images/CrewTiles/Agenttils.svg";
import Space from "../../static/images/CrewTiles/Spacetils.svg";
import Training from "../../static/images/CrewTiles/Trainingtils.svg";
import Output from "../../static/images/Outputtils.svg";
import TrainerTile from "../../static/svg/TrainerTile";
import Description from "../../static/images/CrewTiles/Discriptiontils.svg";
import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import RightArrowIcon from "../../static/svg/RightArrowIcon";
import LeftArrowIcon from "../../static/svg/LeftArrowIcon";
import CenterArrowIco from "../../static/svg/CenterArrowIco";
import AnalyzeTileIcon from "../../static/svg/AnalyzeTileIcon";
import PrepareTile from "../../static/svg/PrepareTile";
import { service } from "../../../services/AxiosServices";
import { usePhase } from "../../../context/PhaseContext";
import Analyze from "../../static/svg/Analyze";
import Prepare from "../../static/svg/Prepare";
import Buildwhiteicon from "../../static/svg/Buildwhiteicon";
import Deploywhiteicon from "../../static/svg/Deploywhiteicon";
import Finetunewhite from "../../static/svg/Finetunewhite";
import Trainerwhiteicon from "../../static/svg/Trainerwhiteicon";

// CrewScreen displays a set of clickable tiles for different crew-related actions,
// with a check for whether the crew is in edit mode.grid

interface CrewNameProps {
  crewName?: string;
  crewId?: string;
  showScroll?: Boolean;
}

const CrewScreen: FC<CrewNameProps> = ({ crewName, crewId, showScroll }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isEditCrew = location.pathname.includes("/edit_crew");
  const crewConfig = location.pathname.includes("/crew-configurations");
  const addCrew = location.pathname.includes("/add_crew");
  const crewBuild = location.pathname.includes("/crew-build");

  const { getPhase, fetchPhase,fetchTrainingRecords,getAnalyzedRecordsCount } = usePhase();
  const analyzedData = getAnalyzedRecordsCount(Number(crewId))

  useEffect(() => {
  if (crewId) {
    fetchPhase(Number(crewId), "crew");
    service<{ data: any[] }>(
      "api/fetch-analyse-docs/",
      "post",
      {
        entity_id: crewId,
        entity_type: "Crew"
      }
    ).then(response => {
      if (response?.data?.data) {
        fetchTrainingRecords(Number(crewId), response.data.data);
      }
    }).catch(err => {
      console.error("Error loading analyzed records:", err);
    });
  }
}, [crewId]);
  const handleClick = (path: string, state?: any) => {
    if (addCrew) {
      toast.warning("Please create a crew first!", {
        autoClose: 2000,
        position: "top-center",
      });
    } else {
      navigate(path, { state });
    }
  };
  const handleAdd = () => { };

  const tiles = [
    // ...(isEditCrew ? [
    //   { name: "Analyze", path: `/crew-configurations/${crewId}`, icon: ConfigurationsTileIcon },
    //   { name: "Prepare", path: `/crew-build/${crewId}`, icon: BuildCrewTileIcon },
    //   { name: "Build", path: `/crew-build/${crewId}`, icon: BuildCrewTileIcon },
    //   { name: "Training center", path: `/training/${crewId}/upload`, icon: KnowledgehubIcon },
    //   { name: "Finetuning center", path: `/finetune_response/${crewId}`, icon: FinetureTile },
    //   { name: "Deploy", path: "", icon: DeployCrewTileIcon },

    //   { name: "Crew Configurations", path: `/crew-configurations/${crewId}`, icon: ConfigurationsTileIcon },

    // ] : []),

    ...(crewConfig
      ? [
        { name: "Users", path: `/user-page/crew/${crewId}`, icon: UserIcon },
        {
          name: "Details",
          path: `/crew_detail/${crewId}`,
          icon: DetailsIcon,
        },
      ]
      : []),

    ...(crewBuild
      ? [
        { name: "Agents", path: `/agents/${crewId}`, icon: AgentsCrewsIcon },
        {
          name: "Frequency",
          path: `/frequency/${crewId}`,
          icon: FrequencyCrewIcon,
        },
        { name: "Flows", path: `/flows/${crewId}`, icon: FlowsCrewIcon },
        { name: "Logs", path: `/logs/${crewId}`, icon: LogsIcon },
      ]
      : []),
    ...(addCrew
      ? [
        { name: "Users", path: `/user-page/crew/${crewId}`, icon: UserIcon },
        { name: "Agents", path: `/agents/${crewId}`, icon: AgentsCrewsIcon },
        {
          name: "Details",
          path: `/crew_detail/${crewId}`,
          icon: DetailsIcon,
        },
        { name: "Flows", path: `/flows/${crewId}`, icon: FlowsCrewIcon },
        {
          name: "Knowledge hub",
          path: `/training/${crewId}/upload`,
          icon: KnowledgehubIcon,
        },
        { name: "Logs", path: `/logs/${crewId}`, icon: LogsIcon },
        {
          name: "Knowledge hub explorer",
          path: `/ai_space/${crewId}`,
          icon: KnowledgehubchatgptIcon,
        },
        // { name: "Output configuration", path: `/output/${crewId}`, icon: Output},
        {
          name: "Frequency",
          path: `/frequency/${crewId}`,
          icon: FrequencyCrewIcon,
        },
        {
          name: "Finetune",
          path: `/finetune_response/${crewId}`,
          icon: FineTuneIcon,
        },
        {
          name: "Final output",
          path: `/response/${crewId}`,
          icon: FinalOutput,
        },
      ]
      : []),
  ];
  const content = (
    <div
      className={
        isEditCrew || crewConfig || crewBuild ? "Edit_crew_window" : ""
      }
    >
      <div
        className={
          isEditCrew || crewConfig || crewBuild ? " All-cards p-3" : "All-cards"
        }
      >
        {tiles.map((tile, index) => (
          <div
            key={index}
            className="col crew-info"
            onClick={() => handleClick(tile.path, { crewName })}
            style={{ cursor: "pointer" }}
          >
            <div className="assigned_tiles_inner activate">
              {typeof tile.icon === "string" ? (
                <img src={tile.icon} alt={tile.name} />
              ) : (
                <tile.icon />
              )}
              <div className="tile mt-3">{tile.name}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );


  return (
    <>
      {!addCrew && (
        <SectionHeader
          back={true}
          title={`Crew: ${crewName || "crew"}`}
          action="Create"
          onAdd={crewBuild ? handleAdd : undefined}
        ></SectionHeader>
      )}

      {showScroll === undefined ? (
        <WindowHeightComponent className={""}>
          {isEditCrew && (
            <>
              <div className="d-flex flex-column h-100">
                <div className="d-flex align-items-center p-3">
                  <div className="flex-1">
                    <div className="workflow-container-grid mb-5">
                      <div
                        style={
                          getPhase(Number(crewId)) === 0  &&  analyzedData?
                          { backgroundColor: "#FD7E14", color: "white" }:
                          getPhase(Number(crewId)) >= 1
                            ? { backgroundColor: "#17b73b", color: "white" }
                            : {}
                        }
                        onClick={() => navigate(`/crew-analyzed-records/${crewId}`)}
                        className="tiles"
                      >
                        <div className="mb-2">
                          {getPhase(Number(crewId)) >= 1 ? <Analyze /> : <AnalyzeTileIcon />}
                        </div>

                        <div className="">Analyze</div>
                      </div>

                      <div className="arrow d-flex align-items-center">
                        <span>
                          <RightArrowIcon />
                        </span>
                      </div>
                      <div
                        style={
                          getPhase(Number(crewId)) === 1
                            ? { backgroundColor: "#FD7E14", color: "white" }
                            : getPhase(Number(crewId)) >= 2
                              ? { backgroundColor: "#17b73b", color: "white" }
                              : {}
                        }
                        onClick={() => navigate(`/crew-prepared-records/${crewId}`)}
                        className="tiles"
                      >
                        <div className="mb-2">
                          {getPhase(Number(crewId)) >= 1 ? <Prepare /> : <PrepareTile />}
                        </div>

                        <div className="">Prepare</div>
                      </div>

                      <div className="arrow d-flex align-items-center">
                        <span>
                          <RightArrowIcon />
                        </span>
                      </div>
                      <div
                        style={
                          getPhase(Number(crewId)) >= 3
                            ? { backgroundColor: "#17b73b", color: "white" }
                            : getPhase(Number(crewId)) === 2
                              ? { backgroundColor: "#FD7E14", color: "white" }
                              : {}
                        }
                        onClick={() => navigate(`/crew-build/${crewId}`)}
                        className="tiles"
                      >
                        <div className="mb-2">
                          {getPhase(Number(crewId)) >= 2 ? <Buildwhiteicon /> : <BuildCrewTileIcon />}
                        </div>
                        <div className="">Build</div>
                      </div>

                    </div>

                    <div className="workflow-container-grid">

                      {/* Deploy Tile (Static - no getPhase logic, just always show colored icon?) */}
                      <div className="tiles">
                        <div className="mb-2">
                          <DeployCrewTileIcon />
                          {/* Show white icon conditionally if needed */}
                          {/* {getPhase(Number(crewId)) >= x ? <Deploywhiteicon /> : <DeployCrewTileIcon />} */}
                        </div>
                        <div className="">Deploy</div>
                      </div>

                      <div className="arrow d-flex align-items-center">
                        <span>
                          <LeftArrowIcon />
                        </span>
                      </div>

                      {/* Finetuning Center Tile */}
                      <div
                        style={
                          getPhase(Number(crewId)) >= 5
                            ? { backgroundColor: "#17b73b", color: "white" }
                            : getPhase(Number(crewId)) === 4
                              ? { backgroundColor: "#FD7E14", color: "white" }
                              : {}
                        }
                        onClick={() => navigate(`/finetune_response/${crewId}`)}
                        className="tiles"
                      >
                        <div className="mb-2">
                          {getPhase(Number(crewId)) >= 4 ? <Finetunewhite /> : <FinetureTile />}
                        </div>
                        <div className="">Finetuning center</div>
                      </div>

                      <div className="arrow d-flex align-items-center">
                        <span>
                          <LeftArrowIcon />
                        </span>
                      </div>

                      {/* Training Center Tile */}
                      <div
                        style={
                          getPhase(Number(crewId)) >= 4
                            ? { backgroundColor: "#17b73b", color: "white" }
                            : getPhase(Number(crewId)) === 3
                              ? { backgroundColor: "#FD7E14", color: "white" }
                              : {}
                        }
                        onClick={() => navigate(`/training-crew/${crewId}/upload`)}
                        className="tiles"
                      >
                        <div className="mb-2">
                          {getPhase(Number(crewId)) >= 3 ? <Trainerwhiteicon /> : <TrainerTile />}
                        </div>
                        <div className="">Training center</div>
                      </div>

                    </div>


                  </div>
                  <div>
                    <div>
                      <span>
                        <CenterArrowIco />
                      </span>
                    </div>
                  </div>
                </div>
                <div className="px-3 my-1">
                  <hr />
                </div>
                <div className="workflow-container-grid p-3 mt-auto">
                  <div
                    onClick={() => navigate(`/crew-configurations/${crewId}`)}
                    className="tiles"
                  >
                    <div className="mb-2">
                      <ConfigurationsTileIcon />
                    </div>
                    <div className="">Configurations</div>
                  </div>
                </div>
              </div>

            </>
          )}
          {/* {content} */}
        </WindowHeightComponent>
      ) : (
        ""
      )}
    </>
  );
};

export default CrewScreen;
